import { render, staticRenderFns } from "./StepRequestedDocuments.vue?vue&type=template&id=73c041fa"
import script from "./StepRequestedDocuments.vue?vue&type=script&lang=js"
export * from "./StepRequestedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports